module.exports = __webpack_public_path__ + "static/media/2.ac7c276b.png";